import { useTranslation } from "react-i18next";
import { withForm } from "@/components/form/form";
import { Text } from "@/components/Text";
import { toValues } from "./connectorValues";

/** Sign-in settings (authMode oauth): the OAuth app registered with the provider. */
export const OAuthFields = withForm({
  defaultValues: toValues(),
  render: function OAuthFieldsRender({ form }) {
    const { t } = useTranslation("connectors");
    return (
      <div className="flex flex-col gap-4 border-l-2 border-border-subtle pl-4">
        <Text variant="caption" tone="tertiary">
          {t("form.oauth.help")}
        </Text>
        <form.AppField name="oauthClientId">
          {(field) => <field.TextField label={t("form.oauth.clientId")} required />}
        </form.AppField>
        <form.AppField name="oauthScopes">
          {(field) => (
            <field.TextField label={t("form.oauth.scopes")} placeholder={t("form.oauth.scopesPlaceholder")} />
          )}
        </form.AppField>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <form.AppField name="oauthAuthorizeUrl">
            {(field) => <field.TextField label={t("form.oauth.authorizeUrl")} placeholder={t("form.oauth.found")} />}
          </form.AppField>
          <form.AppField name="oauthTokenUrl">
            {(field) => <field.TextField label={t("form.oauth.tokenUrl")} placeholder={t("form.oauth.found")} />}
          </form.AppField>
        </div>
        <Text variant="caption" tone="tertiary">
          {t("form.oauth.urlsHelp")}
        </Text>
      </div>
    );
  },
});
